/**
 * Prevents popup open outside document
 */
// eslint-disable-next-line import/prefer-default-export
export function roundOffset({
  posX,
  posY,
  contentElement,
}: {
  contentElement: HTMLElement
  posX: number
  posY: number
}) {
  return () => {
    const contentRect = contentElement.getBoundingClientRect()
    const documentRect = document.documentElement.getBoundingClientRect()

    let x = posX
    let y = posY

    if (x + contentRect.width > documentRect.width) {
      x -= x + contentRect.width - documentRect.width
    }

    if (y + contentRect.height > documentRect.height) {
      y -= y + contentRect.height - documentRect.height
    }

    return { x, y }
  }
}
